// Stable IDs are shared by catalogue links and booking; labels are translated separately.
export const serviceCategories = [
  { id: "yachts", services: ["exterior", "bowbottom", "interior", "deck", "polishing"], image: "exterior" },
  { id: "automotive", services: ["detailing"], image: "detailing" },
  { id: "residential", services: ["apartment", "office", "villa"], image: "apartment" },
  { id: "marble", services: ["marble"], image: "marble" },
  { id: "construction", services: ["postconstruction", "construction"], image: "postconstruction" },
];

export const serviceImages = {
  exterior: "https://images.unsplash.com/photo-1597583041561-0e8f2c551474?auto=format&fit=crop&q=75&w=960",
  bowbottom: "https://images.unsplash.com/photo-1597583041561-0e8f2c551474?auto=format&fit=crop&q=75&w=960",
  interior: "https://images.unsplash.com/photo-1697124510322-27ef594f67fd?auto=format&fit=crop&q=75&w=960",
  deck: "https://images.unsplash.com/photo-1701011062690-46a8b216010f?auto=format&fit=crop&q=75&w=960",
  polishing: "https://images.unsplash.com/photo-1738170205722-0011fd42337e?auto=format&fit=crop&q=75&w=960",
  apartment: "/images/work/apartment-09-960.webp",
  office: "https://images.unsplash.com/photo-1631365696563-4990f4e9302c?auto=format&fit=crop&q=75&w=960",
  villa: "https://images.unsplash.com/photo-1758273705601-50b1b61f7e6c?auto=format&fit=crop&q=75&w=960",
  postconstruction: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&q=75&w=960",
  construction: "https://images.unsplash.com/photo-1527515637462-cff94eecc1ac?auto=format&fit=crop&q=75&w=960",
  detailing: "/images/work/detailing-01-960.webp",
  marble: "/images/services/marble.webp",
};

export const categoryForService = (id) => serviceCategories.find(category => category.services.includes(id));
export const bookingLink = (id) => `/contact?category=${categoryForService(id)?.id || ""}&service=${id}`;

export const bookingSelection = (params) => {
  const category = serviceCategories.find(item => item.id === params.get("category"));
  const service = params.get("service");
  return { service_category: category?.id || "", service_type: category?.services.includes(service) ? service : "" };
};